import React from "react";

export default function PrintDocumentHomeDepotCentralText(props) {
  const {styles, isContractSign, receiptEstimatedText} = props;
  const {View, Text} = window.ReactPdfRenderer;
  return (
    <View style={[styles.main, styles.mainTitle2, styles.marginT16]}>
      <View style={[styles.main, styles.mainTitle2Inner, {gap: 18}]}>
        <Text>Estimated Start ** This is an estimate only and NOT a guarantee **</Text>
        <View receiptEstimatedTextField={true} style={{flex: 'auto'}}>
          <Text>{!isContractSign ? receiptEstimatedText : ""}</Text>
        </View>
      </View>
    </View>
  )
}
